import axios from 'axios';

let telegramId = null;

export const setTelegramId = (id) => {
  telegramId = id;
};

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3000/api',
  timeout: 0, // uzun fayl yuklashlarda timeout xatolik bo'lmasligi uchun
});

axiosInstance.interceptors.request.use((config) => {
  if (telegramId) {
    config.headers['x-telegram-id'] = telegramId.toString();
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Xatolik yuz berdi')
);

export default axiosInstance;
